(function () {
'use strict';
var dataEl = document.getElementById('nv-helper-data');
if (!dataEl) return;
var D;
try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
var G = D.guides || {};
var panel = document.getElementById('nv-panel');
var body = document.getElementById('nv-body');
var titleEl = document.getElementById('nv-panel-title');
var backBtn = document.getElementById('nv-back');
var stack = [];
var lastFocus = null;
var PROJECTS = [
['paint-walls', 'Paint a room', 'Walls and ceilings'],
['wallpapering', 'Wallpaper a room', 'Rolls and paste'],
['tiling', 'Tile a wall or floor', 'Tiles, adhesive, grout'],
['insulation-draughts', 'Insulate and stop draughts', 'Loft, doors, windows'],
['shelving-hanging', 'Put up shelves', 'Brackets and fixings'],
['woodcare-outdoor', 'Treat a fence or shed', 'Stains and preservers'],
['paint-wood-metal', 'Paint doors and woodwork', 'Gloss, satin, eggshell'],
['lawn-care', 'Sort out the lawn', 'Seed, feed, weed'],
['adhesive-film', 'Cover with sticky-back film', 'Worktops, doors, glass'],
['sealing', 'Reseal a bath or sink', 'Silicone and sealants'],
['taps-showers', 'Replace a tap or shower head', 'Fitting and parts'],
['damp-mould', 'Deal with damp and mould', 'Treat and prevent']
];
var IC = {
tree: '<path d="M12 2l6 8h-3l4 6h-5v4h-4v-4H5l4-6H6z"/>',
pan: '<circle cx="10" cy="13" r="6"/><path d="M16 13h6"/>',
plug: '<path d="M9 2v5M15 2v5"/><path d="M6 7h12v4a6 6 0 0 1-12 0z"/><path d="M12 17v5"/>',
toolbox: '<rect x="3" y="8" width="18" height="12" rx="1.5"/><path d="M9 8V5h6v3"/><path d="M3 13h18"/>',
roller: '<rect x="3" y="3" width="14" height="6" rx="1.5"/><path d="M17 6h3v5h-8v3"/><rect x="10.5" y="14" width="3" height="7" rx="1"/>',
brush: '<path d="M18 2l4 4-9 9-4-4z"/><path d="M9 11c-3 0-5 2-5 5 0 2-1 3-2 4 4 1 9 0 9-4"/>',
paper: '<path d="M4 3h12a3 3 0 0 1 3 3v15H7a3 3 0 0 1-3-3z"/><path d="M8 8h7M8 12h7M8 16h4"/>',
tiles: '<rect x="3" y="3" width="8" height="8" rx="1"/><rect x="13" y="3" width="8" height="8" rx="1"/><rect x="3" y="13" width="8" height="8" rx="1"/><rect x="13" y="13" width="8" height="8" rx="1"/>',
house: '<path d="M3 11l9-7 9 7"/><path d="M5 10v10h14V10"/><path d="M8 14h8M8 17h8"/>',
shelf: '<path d="M3 8h18M3 16h18"/><path d="M6 8v3l3-3M18 8v3l-3-3M6 16v3l3-3M18 16v3l-3-3"/>',
fence: '<path d="M3 21V7l2-3 2 3v14M10 21V7l2-3 2 3v14M17 21V7l2-3 2 3v14M3 10h18M3 16h18"/>',
lawn: '<path d="M2 21h20"/><path d="M5 21c0-4 1-7 3-9M8 21c0-3 0-6-2-9M12 21c0-5 1-9 4-12M15 21c0-3-1-6-3-8M19 21c0-3 1-5 3-7"/>',
film: '<path d="M4 4h11v16H4z"/><path d="M15 4c2.5 0 5 1.5 5 4v12h-5"/><path d="M7 8h5M7 12h5"/>',
gun: '<rect x="2" y="9" width="12" height="6" rx="1"/><path d="M14 11h4l4-1v4l-4-1h-4"/><path d="M6 15v5h3"/>',
tap: '<path d="M3 9h11a3 3 0 0 1 3 3v2"/><path d="M8 9V5M5 5h6"/><path d="M17 17.5v.5M17 21v.01"/>',
drop: '<path d="M12 3s6 7 6 11a6 6 0 0 1-12 0c0-4 6-11 6-11z"/>',
drill: '<path d="M3 6h11v6H3z"/><path d="M14 8h4M18 9h4"/><path d="M6 12l-1 9h5l1-9"/>',
spanner: '<path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.5 2.5-2.4-.6-.6-2.4z"/>',
bulb: '<path d="M9 18h6M10 21h4"/><path d="M12 3a6 6 0 0 0-4 10.5c.8.8 1 1.5 1 2.5h6c0-1 .2-1.7 1-2.5A6 6 0 0 0 12 3z"/>',
spray: '<path d="M8 8h6l1 13H7z"/><path d="M9 8V5h4l3 2"/><path d="M19 4h.01M21 6h.01M19 8h.01"/>',
box: '<path d="M3 7l9-4 9 4v10l-9 4-9-4z"/><path d="M3 7l9 4 9-4M12 11v10"/>',
ladder: '<path d="M7 2L4 22M17 2l3 20M6.4 6h11.2M5.8 11h12.4M5.1 16h13.8"/>',
plant: '<path d="M12 21v-8"/><path d="M12 13c0-5-4-7-8-7 0 5 4 7 8 7zM12 11c0-4 3-6 8-6 0 4-3 6-8 6z"/><path d="M7 21h10"/>',
rad: '<path d="M4 6v12M8 6v12M12 6v12M16 6v12M20 6v12M2 18h20M2 8h20"/>',
door: '<rect x="5" y="2" width="14" height="20" rx="1"/><circle cx="15" cy="12" r="1"/>',
wardrobe: '<rect x="3" y="2" width="18" height="20" rx="1"/><path d="M12 2v20M10 11v2M14 11v2"/>',
bug: '<ellipse cx="12" cy="14" rx="5" ry="6"/><path d="M12 8V5M9 4l1.5 2M15 4l-1.5 2M7 12H3M21 12h-4M7 17H4M20 17h-3"/>',
floor: '<path d="M2 17l10-5 10 5-10 5z"/><path d="M7 14.5l10 5M12 12l5 2.5"/>',
brick: '<rect x="2" y="5" width="20" height="14" rx="1"/><path d="M2 12h20M8 5v7M16 5v7M12 12v7"/>',
pipe: '<path d="M3 7h8a4 4 0 0 1 4 4v10M3 11h8v10"/><path d="M2 5v8M10 21h8"/>',
hammer: '<path d="M14 3l7 7-3 3-7-7z"/><path d="M12.5 8.5L3 18l3 3 9.5-9.5"/>',
tape: '<circle cx="10" cy="12" r="7"/><circle cx="10" cy="12" r="3"/><path d="M17 12h5"/>',
can: '<path d="M5 9h10v11H5z"/><path d="M15 12l6-5M5 11H2"/><path d="M8 9V6h4v3"/>',
spade: '<path d="M12 2v12M10 2h4"/><path d="M8 14h8v3a4 4 0 0 1-8 0z"/>',
knife: '<path d="M9 15l-6 6"/><path d="M9 15l12-12v7l-6 6z"/>'
};
var KEYIC = { 'paint-walls': 'roller', 'paint-wood-metal': 'brush', 'woodcare-outdoor': 'fence', 'decorating-tools': 'roller', 'prep-filling': 'knife', 'wallpapering': 'paper', 'adhesive-film': 'film', 'tiling': 'tiles', 'sealing': 'gun', 'adhesives-tape': 'tape', 'fixings-drilling': 'drill', 'shelving-hanging': 'shelf', 'hand-tools': 'hammer', 'power-tools': 'drill', 'door-security': 'door', 'wardrobes-cabinets': 'wardrobe', 'taps-showers': 'tap', 'plumbing': 'pipe', 'electrical-lighting': 'bulb', 'insulation-draughts': 'house', 'heating': 'rad', 'damp-mould': 'drop', 'lawn-care': 'lawn', 'garden-growing': 'plant', 'garden-watering': 'can', 'garden-tools': 'spade', 'outdoor-cleaning': 'spray', 'pest-control': 'bug', 'cleaning': 'spray', 'storage': 'box', 'ladders-safety': 'ladder', 'flooring': 'floor', 'building': 'brick', 'christmas-decorating': 'tree', 'kitchen-cookware': 'pan', 'small-appliances': 'plug', 'tools-choosing': 'toolbox' };
function icon(key, size) { var n = IC[KEYIC[key]] || IC.spanner; size = size || 24; return '<svg class="nv-ic" width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + n + '</svg>'; }
var GRP = { 'paint-walls': 'dec', 'paint-wood-metal': 'dec', 'decorating-tools': 'dec', 'prep-filling': 'dec', 'wallpapering': 'dec', 'adhesive-film': 'dec', 'tiling': 'dec', 'flooring': 'dec', 'woodcare-outdoor': 'gdn', 'lawn-care': 'gdn', 'garden-growing': 'gdn', 'garden-watering': 'gdn', 'garden-tools': 'gdn', 'pest-control': 'gdn', 'outdoor-cleaning': 'gdn', 'sealing': 'wat', 'taps-showers': 'wat', 'plumbing': 'wat', 'damp-mould': 'wat', 'insulation-draughts': 'hot', 'heating': 'hot', 'electrical-lighting': 'hot', 'cleaning': 'hom', 'storage': 'hom', 'wardrobes-cabinets': 'hom', 'shelving-hanging': 'hom', 'christmas-decorating': 'hot', 'kitchen-cookware': 'hom', 'small-appliances': 'hot' };
function badge(key, size, cls) { return '<span class="nv-badge nv-c-' + (GRP[key] || 'tool') + ' ' + (cls || '') + '">' + icon(key, size) + '</span>'; }
var CLUBIC = '<span class="nv-badge nv-c-club">' + '<svg class="nv-ic" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 11l9-7 9 7"/><path d="M5 10v10h14V10"/><path d="M12 17s-3-1.8-3-3.6a1.6 1.6 0 0 1 3-.8 1.6 1.6 0 0 1 3 .8c0 1.8-3 3.6-3 3.6z"/></svg></span>';
function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
function money(p) { return '£' + (p / 100).toFixed(2); }
function num(v, d) { var n = parseFloat(String(v).replace(',', '.')); return isNaN(n) ? d : n; }
function round1(n) { return Math.round(n * 10) / 10; }
function ceil(n) { return Math.ceil(n - 1e-9); }
var P = D.product || null;
var ptext = P ? (P.title + ' ' + (P.text || '')) : '';
function tinLitres() {
if (!P) return null;
var m = P.title.match(/(\d+(?:\.\d+)?)\s*(ml|ltr|litres?|liters?|l)\b/i);
if (!m) return null;
var v = parseFloat(m[1]);
return /ml/i.test(m[2]) ? v / 1000 : v;
}
function coveragePerLitre(def) {
if (!P) return { v: def, known: false };
var m = ptext.match(/(\d+(?:\.\d+)?)\s*(?:m2|m²|sq\.?\s?m(?:etres?)?|square met(?:re|er)s?)\s*(?:per|\/|a)\s*(?:litre|liter|ltr|l)\b/i);
if (m) return { v: parseFloat(m[1]), known: true };
var t = tinLitres();
m = ptext.match(/covers?\s*(?:up\s*to\s*)?(?:approx(?:imately)?\.?\s*)?(\d+(?:\.\d+)?)\s*(?:m2|m²|sq\.?\s?m|square met)/i);
if (m && t) return { v: parseFloat(m[1]) / t, known: true };
return { v: def, known: false };
}
function packCoverage() {
if (!P) return null;
var m = ptext.match(/(?:covers?|treats?|coverage)\D{0,20}?(\d+(?:\.\d+)?)\s*(?:m2|m²|sq\.?\s?m|square met)/i) || P.title.match(/(\d+(?:\.\d+)?)\s*(?:m2|m²)/i);
return m ? parseFloat(m[1]) : null;
}
function thicknessMm() {
if (!P) return null;
var m = P.title.match(/(\d{2,3})\s*mm/i);
return m ? parseInt(m[1], 10) : null;
}
function filmRoll() {
if (!P) return null;
var m = ptext.match(/(\d+(?:\.\d+)?)\s*cm\s*[x×]\s*(\d+(?:\.\d+)?)\s*m\b/i);
return m ? { w: parseFloat(m[1]), l: parseFloat(m[2]) } : null;
}
var productMatches = function (key) { return P && D.ctx === 'product' && D.key === key; };
function open(view) {
lastFocus = document.activeElement;
panel.hidden = false;
document.documentElement.style.overflow = 'hidden';
stack = [];
body.innerHTML = '';
go(view || home());
setTimeout(function () { var c = document.getElementById('nv-close'); if (c) c.focus(); }, 30);
}
function close() {
panel.hidden = true;
document.documentElement.style.overflow = '';
if (lastFocus && lastFocus.focus) lastFocus.focus();
}
function go(view, push) {
if (push !== false && body.firstChild) stack.push(current);
current = view;
render(view);
}
var current = null;
function back() { if (stack.length) { current = stack.pop(); render(current); } }
function render(v) {
titleEl.textContent = v.title || 'Project helper';
body.innerHTML = '';
v.draw(body);
backBtn.hidden = stack.length === 0;
body.scrollTop = 0;
}
document.getElementById('nv-fab').addEventListener('click', function () { open(); });
document.getElementById('nv-close').addEventListener('click', close);
backBtn.addEventListener('click', back);
panel.addEventListener('click', function (e) { if (e.target === panel) close(); });
document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });
document.addEventListener('click', function (e) {
var t = e.target.closest && e.target.closest('[data-nv-open]');
if (!t) return;
e.preventDefault();
var what = t.getAttribute('data-nv-open');
var parts = what.split(':'), k = parts[1] || D.key;
if ((parts[0] === 'plan' || parts[0] === 'guide') && k && G[k]) {
open(home());
go(parts[0] === 'plan' && G[k].planner ? planView(k) : guideView(k));
} else if (parts[0] === 'club') {
open(clubView());
} else open();
});
(function placeGuide() {
var guide = document.querySelector('[data-nv-guide]');
if (!guide) return;
var main = document.querySelector('[id^="MainProduct-"]');
var sec = main ? main.closest('.shopify-section') : document.querySelector('.shopify-section[id*="__main"]');
if (sec && sec.parentNode) sec.parentNode.insertBefore(guide, sec.nextSibling);
})();
(function placeTeaser() {
if (D.ctx !== 'product' || !D.key || !G[D.key] || document.getElementById('nv-howto-link')) return;
var g = G[D.key];
var anchor = document.querySelector('.product__info-container [id^="price-"]') || document.querySelector('[id^="price-"]') || document.querySelector('.product-form__buttons');
if (!anchor) return;
var nx = anchor.nextElementSibling;
if (nx && /product__tax/.test(nx.className)) anchor = nx;
var b = document.createElement('button');
b.type = 'button'; b.id = 'nv-howto-link'; b.className = 'nv-teaser'; b.setAttribute('data-nv-open', 'plan');
b.innerHTML = '' + badge(D.key, 30, 'nv-teaser__ic') + '<span class="nv-teaser__txt"><strong>' + (g.planner ? 'Not sure how much you need?' : esc(g.title)) + '</strong><small>' + (g.planner ? 'Enter your sizes for a quick plan, shopping list and tips' : esc(g.blurb || 'Tips, safety and what else you will need')) + '</small></span><span class="nv-teaser__go">' + (g.planner ? 'Plan it' : 'Show me') + ' &rarr;</span>';
anchor.parentNode.insertBefore(b, anchor.nextSibling);
var c = document.createElement('button');
c.type = 'button'; c.className = 'nv-clubline'; c.setAttribute('data-nv-open', 'club');
c.innerHTML = CLUBIC + '<span><strong>Free Nurvale Home Club:</strong> seasonal home reminders and early offers</span><span class="nv-clubline__go">Join &rarr;</span>';
b.parentNode.insertBefore(c, b.nextSibling);
})();
(function placeBanner() {
if (D.ctx !== 'collection') return;
var first = document.querySelector('main > .shopify-section');
if (!first) return;
var g = D.key && G[D.key];
var d = document.createElement('div');
d.className = 'nv-banner page-width';
d.innerHTML = '';
if (g) d.innerHTML = '<div class="nv-banner__in">' + badge(D.key, 36, 'nv-banner__art') + '<div class="nv-banner__txt"><small class="nv-banner__eyebrow">Free project helper</small><strong>' + esc(g.title) + '</strong><span>' + esc(g.blurb || (g.planner ? 'Work out how much you need and get a shopping list.' : 'Step-by-step tips and the products for the job.')) + '</span></div><div class="nv-banner__btns"><button type="button" class="nv-btn" data-nv-open="' + (g.planner ? 'plan' : 'guide') + ':' + esc(D.key) + '">' + (g.planner ? 'Work out what I need' : 'See the guide') + '</button><button type="button" class="nv-btn nv-btn--ghost" data-nv-open="home">Other projects</button></div></div>';
d.innerHTML += '<button type="button" class="nv-clubline nv-clubline--wide" data-nv-open="club">' + CLUBIC + '<span><strong>Join the free Nurvale Home Club:</strong> reminders for seasonal home jobs, your project plans by email and early access to offers</span><span class="nv-clubline__go">Join &rarr;</span></button>';
first.parentNode.insertBefore(d, first.nextSibling);
})();
(function fillTiles() {
document.querySelectorAll('[data-nv-tiles]').forEach(function (box) {
var n = parseInt(box.getAttribute('data-nv-tiles'), 10) || 8;
box.innerHTML = PROJECTS.slice(0, n).map(function (p) {
var g = G[p[0]]; if (!g) return '';
return '<button type="button" class="nv-pchip" data-nv-open="' + (g.planner ? 'plan' : 'guide') + ':' + p[0] + '">' + badge(p[0], 20) + '<span>' + esc(p[1]) + '</span></button>';
}).join('');
});
})();
function clubForm(src) {
return '<form class="nv-clubform" data-nv-club-form="' + src + '" novalidate><input type="email" name="email" autocomplete="email" placeholder="Your email address" aria-label="Email address" required><button type="submit">Join free</button></form><p class="nv-clubform__small">Free to join. We will email you about seasonal home jobs and offers. Unsubscribe at any time.</p><div class="nv-msg" role="status"></div>';
}
function clubView() {
return {
title: 'Nurvale Home Club',
draw: function (el) {
el.innerHTML = '<div class="nv-clubhero">' + CLUBIC + '<div><strong>Look after your home all year</strong><small>Free to join</small></div></div><ul class="nv-perks"><li><b>Seasonal reminders</b> for the jobs that save money and trouble: boiler service, gutters, frost protection, draughts, damp checks.</li><li><b>What you will need</b> for each job, with our project helper to work out quantities.</li><li><b>Your project plans</b> and shopping lists sent to your inbox.</li><li><b>Early access</b> to offers and new ranges.</li></ul>' + clubForm('panel');
}
};
}
document.addEventListener('submit', function (e) {
var f = e.target.closest && e.target.closest('[data-nv-club-form]');
if (!f) return;
e.preventDefault();
var em = (f.email.value || '').trim(), msg = f.parentNode.querySelector('.nv-msg');
if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) { msg.className = 'nv-msg nv-msg--err'; msg.textContent = 'Please enter a valid email address.'; return; }
var btn = f.querySelector('button'); btn.disabled = true;
subscribe(em, D.club, 'Home Club - ' + f.getAttribute('data-nv-club-form')).then(function () {
f.style.display = 'none';
msg.className = 'nv-msg nv-msg--ok'; msg.textContent = 'Welcome to the Home Club. Your first email is on its way.';
try { localStorage.setItem('nvClub', '1'); } catch (x) {}
}).catch(function () { btn.disabled = false; msg.className = 'nv-msg nv-msg--err'; msg.textContent = 'Sorry, that did not work. Please try again.'; });
});
document.querySelectorAll('[data-nv-club-slot]').forEach(function (s) { s.innerHTML = clubForm(s.getAttribute('data-nv-club-slot')); });
(function nudge() {
if (D.ctx !== 'product' || !D.key || !G[D.key]) return;
try { if (sessionStorage.getItem('nvNudge')) return; } catch (e) {}
setTimeout(function () {
if (!panel.hidden) return;
var fab = document.getElementById('nv-fab');
var n = document.createElement('div');
n.className = 'nv-nudge'; n.setAttribute('role', 'status');
n.innerHTML = '<button type="button" class="nv-nudge__x" aria-label="Close">&times;</button><strong>Not sure how much to buy?</strong> Tap here and we will work it out for you.';
n.addEventListener('click', function (e) { n.remove(); if (!e.target.classList.contains('nv-nudge__x')) fab.click(); });
document.body.appendChild(n);
fab.classList.add('nv-fab--pulse');
try { sessionStorage.setItem('nvNudge', '1'); } catch (e) {}
setTimeout(function () { if (n.parentNode) n.remove(); }, 12000);
}, 6000);
})();
function home() {
if (D.key && G[D.key] && D.ctx === 'product') return guideView(D.key);
return {
title: 'Project helper',
draw: function (el) {
var g = D.key && G[D.key];
var h = '<div class="nv-intro"><div class="nv-intro__art">' + badge('paint-walls', 26) + badge('woodcare-outdoor', 26) + badge('taps-showers', 26) + badge('insulation-draughts', 26) + '</div><p>Tell us what you are working on. We will show you how to do it, work out how much you need and build your shopping list.</p><ol class="nv-how"><li><b>1</b>Pick a project</li><li><b>2</b>Enter your sizes</li><li><b>3</b>Get your list</li></ol></div>';
if (g) h += '<button type="button" class="nv-feature" data-k="' + esc(D.key) + '">' + badge(D.key, 30, 'nv-feature__ic') + '<span><small>Suggested for this page</small><strong>' + esc(g.title) + '</strong></span><span aria-hidden="true">&rarr;</span></button><h3>Or pick another project</h3>';
h += '<div class="nv-projects">' + PROJECTS.map(function (p) {
return '<button type="button" class="nv-proj" data-k="' + p[0] + '">' + badge(p[0], 26, 'nv-proj__ic') + '<strong>' + esc(p[1]) + '</strong><span>' + esc(p[2]) + '</span></button>';
}).join('') + '</div>';
h += '<button type="button" class="nv-clubline nv-clubline--panel" data-nv-open="club">' + CLUBIC + '<span><strong>Free Home Club:</strong> seasonal reminders and early offers</span><span class="nv-clubline__go">Join &rarr;</span></button>';
el.innerHTML = h;
el.querySelectorAll('[data-k]').forEach(function (b) { b.addEventListener('click', function () { go(guideView(b.getAttribute('data-k'))); }); });
}
};
}
function needsHtml(key) {
var g = G[key];
var picks = (D.key === key && D.picks) ? D.picks : [];
var byLabel = {};
picks.forEach(function (p) { byLabel[p.label] = p; });
var cards = [], links = [];
(g.needs || []).forEach(function (n) {
var p = byLabel[n.label];
if (p) cards.push('<a class="nv-card" href="' + esc(p.url) + '"><img src="' + esc(p.image || '') + '" alt="" loading="lazy" width="120" height="120"><small>' + esc(n.label) + '</small><span>' + esc(p.title) + '</span><b>' + money(p.price) + '</b></a>');
else links.push('<a class="nv-chip" href="/collections/' + esc(n.handle) + '">' + esc(n.label) + ' &rarr;</a>');
});
return (cards.length ? '<div class="nv-cards">' + cards.join('') + '</div>' : '') + (links.length ? '<div class="nv-chips">' + links.join('') + '</div>' : '');
}
function guideView(key) {
var g = G[key];
return {
title: g.title,
draw: function (el) {
var h = '<div class="nv-hero nv-hero--' + (GRP[key] || 'tool') + '">' + badge(key, 34, 'nv-hero__ic') + '<div><strong>' + esc(g.title) + '</strong><small>' + g.steps.length + ' steps' + (g.planner ? ' &middot; quantity planner' : '') + ' &middot; shopping list</small></div></div>';
if (P && D.ctx === 'product' && D.key === key && P.image) h += '<div class="nv-prodline"><img src="' + esc(P.image) + '" alt="" width="44" height="44"><span>Guide for <strong>' + esc(P.title) + '</strong></span></div>';
h += '<p>' + esc(g.summary) + '</p>';
if (g.planner) h += '<button type="button" class="nv-btn" id="nv-go-plan">Work out how much you need &rarr;</button>';
h += '<h3>Step by step</h3><ol class="nv-steps">' + g.steps.map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('') + '</ol>';
h += '<h3>Tips</h3><ul class="nv-list">' + g.tips.map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('') + '</ul>';
if (g.safety && g.safety.length) h += '<div class="nv-safety"><strong>Safety</strong><ul>' + g.safety.map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('') + '</ul></div>';
h += '<h3>You might also need</h3>' + needsHtml(key);
h += '<p class="nv-muted" style="margin-top:12px">General guidance only. Always follow the instructions on the product and its packaging.</p>';
el.innerHTML = h;
var b = el.querySelector('#nv-go-plan');
if (b) b.addEventListener('click', function () { go(planView(key)); });
}
};
}
function field(name, label, val, opts) {
opts = opts || {};
if (opts.select) return '<label class="' + (opts.full ? 'nv-full' : '') + '">' + label + '<select name="' + name + '">' + opts.select.map(function (o) { return '<option value="' + o[0] + '"' + (String(o[0]) === String(val) ? ' selected' : '') + '>' + o[1] + '</option>'; }).join('') + '</select></label>';
if (opts.check) return '<label class="nv-check nv-full"><input type="checkbox" name="' + name + '"' + (val ? ' checked' : '') + '> ' + label + '</label>';
return '<label class="' + (opts.full ? 'nv-full' : '') + '">' + label + '<input name="' + name + '" type="number" inputmode="decimal" min="0" step="' + (opts.step || '0.1') + '" value="' + val + '"></label>';
}
function formVals(form) {
var o = {};
Array.prototype.forEach.call(form.elements, function (e) {
if (!e.name) return;
o[e.name] = e.type === 'checkbox' ? e.checked : e.value;
});
return o;
}
var PLANNERS = {
paint: function (key) {
if (key === 'paint-wood-metal') return {
fields: field('doors', 'Doors (both sides)', 2, { step: 1 }) + field('skirting', 'Skirting board (metres)', 14) + field('frames', 'Window frames', 1, { step: 1 }) + field('rads', 'Radiators', 1, { step: 1 }) + field('coats', 'Coats', 2, { select: [[1, '1'], [2, '2'], [3, '3']] }),
calc: function (v) {
var area = num(v.doors, 0) * 3.4 + num(v.skirting, 0) * 0.15 + num(v.frames, 0) * 1.2 + num(v.rads, 0) * 1.6;
return paintResult(key, area, num(v.coats, 2), 14, null);
}
};
if (key === 'woodcare-outdoor') return {
fields: field('panels', 'Fence panels (6ft x 6ft)', 6, { step: 1 }) + field('sides', 'Sides', 1, { select: [[1, 'One side'], [2, 'Both sides']] }) + field('shed', 'Shed / summerhouse area (m²)', 0) + field('deck', 'Decking area (m²)', 0) + field('coats', 'Coats', 2, { select: [[1, '1'], [2, '2']] }),
calc: function (v) {
var area = num(v.panels, 0) * 3.35 * num(v.sides, 1) + num(v.shed, 0) + num(v.deck, 0);
return paintResult(key, area, num(v.coats, 2), 6, null);
}
};
return {
fields: field('L', 'Room length (m)', 4) + field('W', 'Room width (m)', 3.5) + field('H', 'Wall height (m)', 2.4) + field('coats', 'Coats', 2, { select: [[1, '1'], [2, '2'], [3, '3']] }) + field('doors', 'Doors', 1, { step: 1 }) + field('windows', 'Windows', 1, { step: 1 }) + field('ceiling', 'Paint the ceiling too', false, { check: true }) + field('walls', 'Paint the walls', true, { check: true }),
calc: function (v) {
var L = num(v.L, 0), W = num(v.W, 0), H = num(v.H, 0);
var walls = v.walls ? Math.max(0, 2 * (L + W) * H - num(v.doors, 0) * 1.9 - num(v.windows, 0) * 1.5) : 0;
var ceil_ = v.ceiling ? L * W : 0;
return paintResult(key, walls + ceil_, num(v.coats, 2), 12, { L: L, W: W, H: H, doors: num(v.doors, 0), windows: num(v.windows, 0), mode: 'paint' });
}
};
},
wallpaper: function () {
return {
fields: field('L', 'Room length (m)', 4) + field('W', 'Room width (m)', 3.5) + field('H', 'Wall height (m)', 2.4) + field('rep', 'Pattern repeat (cm)', 0, { step: 1 }) + field('doors', 'Doors', 1, { step: 1 }) + field('windows', 'Windows', 1, { step: 1 }) + field('walls', 'How many walls', 4, { select: [[1, 'One feature wall'], [4, 'All four walls']] }),
calc: function (v) {
var L = num(v.L, 0), W = num(v.W, 0), H = num(v.H, 0);
var run = num(v.walls, 4) === 1 ? Math.max(L, W) : 2 * (L + W) - num(v.doors, 0) * 0.8 - num(v.windows, 0) * 0.6;
var drops = ceil(Math.max(0, run) / 0.53);
var dropLen = H + 0.1 + num(v.rep, 0) / 100;
var perRoll = Math.max(1, Math.floor(10.05 / dropLen));
var rolls = ceil(drops / perRoll) + (drops > 8 ? 1 : 0);
var lines = [drops + ' lengths of ' + round1(dropLen) + 'm, ' + perRoll + ' from each standard roll (10.05m x 53cm).', 'We added one spare roll for larger rooms, in case of mistakes.', 'Wallpaper paste: about ' + ceil(rolls / 5) + ' packet(s). Check the coverage on the pack.'];
return { big: rolls + ' rolls', lines: lines, items: mainItem('wallpapering', rolls), room: { L: L, W: W, H: H, doors: num(v.doors, 0), windows: num(v.windows, 0), mode: 'paper' } };
}
};
},
tiles: function (key) {
var floor = key === 'flooring';
return {
fields: field('where', 'Where', floor ? 'floor' : 'wall', { select: [['wall', 'Wall'], ['floor', 'Floor']] }) + field('A', 'Length or width of area (m)', floor ? 3 : 2) + field('B', floor ? 'Other side (m)' : 'Height (m)', floor ? 2.5 : 1.2) + field('tw', 'Tile width (cm)', floor ? 30 : 20, { step: 1 }) + field('th', 'Tile height (cm)', floor ? 60 : 25, { step: 1 }),
calc: function (v) {
var area = num(v.A, 0) * num(v.B, 0);
var tA = (num(v.tw, 30) * num(v.th, 30)) / 10000;
var tiles = tA > 0 ? ceil(area * 1.1 / tA) : 0;
var isFloor = v.where === 'floor';
var lines = ['Area: ' + round1(area) + 'm², plus 10% for cuts and breakages.', 'Adhesive: about ' + ceil(area * (isFloor ? 4 : 3)) + 'kg (powder) for ' + (isFloor ? 'floors' : 'walls') + '.', 'Grout: about ' + round1(Math.max(0.5, area * 0.5)) + 'kg for 3mm joints.', 'Spacers, and silicone for edges where tiles meet baths or worktops.'];
var pc = productMatches(key) ? packCoverage() : null;
var items = pc ? mainItem(key, ceil(area * 1.1 / pc)) : [];
return { big: tiles + ' tiles', lines: lines, items: items, room: { L: isFloor ? num(v.A, 0) : num(v.A, 0), W: isFloor ? num(v.B, 0) : 2.5, H: isFloor ? 2.4 : Math.max(num(v.B, 0), 2.4), mode: isFloor ? 'floor' : 'wall', tile: [num(v.tw, 30), num(v.th, 30)], tileH: num(v.B, 0) } };
}
};
},
insulation: function () {
return {
fields: field('L', 'Loft length (m)', 7) + field('W', 'Loft width (m)', 5) + field('have', 'Insulation there now', 100, { select: [[0, 'None'], [25, 'About 25mm'], [50, 'About 50mm'], [100, 'About 100mm'], [150, 'About 150mm'], [200, 'About 200mm']] }) + field('doors', 'Outside doors to draught-proof', 2, { step: 1 }) + field('windows', 'Windows to draught-proof', 6, { step: 1 }),
calc: function (v) {
var area = num(v.L, 0) * num(v.W, 0);
var top = Math.max(0, 270 - num(v.have, 0));
var lines = ['Loft area: ' + round1(area) + 'm². Top up by about ' + top + 'mm to reach 270mm.'];
var items = [];
var th = productMatches('insulation-draughts') ? thicknessMm() : null;
var pc = productMatches('insulation-draughts') ? packCoverage() : null;
var rolls = null;
if (th && pc && top > 0) {
var layers = ceil(top / th);
rolls = ceil(area * layers / pc);
lines.push(layers + ' layer(s) of this ' + th + 'mm roll, covering ' + pc + 'm² each.');
items = mainItem('insulation-draughts', rolls);
} else if (top > 0) {
lines.push('Divide ' + round1(area) + 'm² by the coverage on the roll, for each layer you need.');
}
var strip = num(v.doors, 0) * 5.4 + num(v.windows, 0) * 4.5;
if (strip > 0) lines.push('Draught strip: about ' + ceil(strip) + ' metres, plus ' + num(v.doors, 0) + ' door bottom excluder(s) and a letterbox brush.');
return { big: rolls ? rolls + ' rolls' : round1(area) + 'm² of loft', lines: lines, items: items };
}
};
},
shelf: function () {
return {
fields: field('len', 'Shelf length (cm)', 90, { step: 1 }) + field('n', 'Number of shelves', 1, { step: 1 }) + field('load', 'What will go on it', 'medium', { select: [['light', 'Light (ornaments, photos)'], ['medium', 'Medium (books, plants)'], ['heavy', 'Heavy (tools, large books)']], full: true }) + field('wall', 'Wall type', 'brick', { select: [['brick', 'Brick or block'], ['plasterboard', 'Plasterboard (hollow)'], ['timber', 'Timber or studs']], full: true }),
calc: function (v) {
var spacing = { light: 80, medium: 60, heavy: 40 }[v.load] || 60;
var per = Math.max(2, ceil(num(v.len, 0) / spacing) + 1);
var n = Math.max(1, num(v.n, 1));
var br = per * n, screws = br * 2;
var fix = { brick: screws + ' wall plugs (to match your screw size) and ' + screws + ' screws, about 50mm long. Use a masonry drill bit.', plasterboard: screws + ' cavity or plasterboard fixings rated for the load. For heavy loads, fix into the timber studs instead.', timber: screws + ' wood screws, at least 40mm long. Drill a small pilot hole first.' }[v.wall];
var lines = [per + ' brackets per shelf, no more than ' + spacing + 'cm apart.', fix, 'A spirit level and a cable and pipe detector.'];
return { big: br + ' brackets', lines: lines, items: mainItem('shelving-hanging', br) , shelf: { len: num(v.len, 0), per: per } };
}
};
},
lawn: function () {
return {
fields: field('L', 'Lawn length (m)', 10) + field('W', 'Lawn width (m)', 6) + field('job', 'What do you want to do', 'over', { select: [['new', 'Sow a new lawn'], ['over', 'Thicken a thin lawn'], ['feed', 'Feed the lawn']], full: true }),
calc: function (v) {
var area = num(v.L, 0) * num(v.W, 0);
var lines = ['Lawn area: ' + round1(area) + 'm².'];
var big;
if (v.job === 'new') { big = round1(area * 35 / 1000) + 'kg seed'; lines.push('About 35g of seed per m² for a new lawn.'); }
else if (v.job === 'over') { big = round1(area * 20 / 1000) + 'kg seed'; lines.push('About 20g of seed per m² to thicken a lawn.'); }
else { big = round1(area) + 'm² to feed'; lines.push('Check how many m² each pack treats.'); }
var pc = productMatches('lawn-care') ? packCoverage() : null;
var items = pc ? mainItem('lawn-care', ceil(area / pc)) : [];
if (pc) lines.push('This pack treats about ' + pc + 'm².');
return { big: big, lines: lines, items: items };
}
};
},
film: function () {
var r = productMatches('adhesive-film') ? filmRoll() : null;
return {
fields: field('w', 'Surface width (cm)', 60, { step: 1 }) + field('h', 'Surface length (cm)', 120, { step: 1 }) + field('n', 'How many surfaces', 1, { step: 1 }) + field('rw', 'Roll width (cm)', r ? r.w : 45, { step: 1 }) + field('rl', 'Roll length (m)', r ? r.l : 2),
calc: function (v) {
var w = num(v.w, 0), h = num(v.h, 0), n = Math.max(1, num(v.n, 1)), rw = Math.max(1, num(v.rw, 45)), rl = Math.max(0.1, num(v.rl, 2));
var strips = ceil(w / rw);
var metres = n * strips * (h + 3) / 100 * 1.1;
var rolls = ceil(metres / rl);
return { big: rolls + ' roll' + (rolls === 1 ? '' : 's'), lines: [strips + ' strip(s) per surface, ' + round1(metres) + 'm in total with 10% spare.', 'A squeegee or soft cloth and a sharp craft knife.'], items: mainItem('adhesive-film', rolls) };
}
};
}
};
function mainItem(key, qty) {
if (!productMatches(key) || !qty) return [];
return [{ title: P.title, url: P.url, variantId: P.variantId, price: P.price, image: P.image, qty: qty, checked: P.available !== false, main: true }];
}
function paintResult(key, area, coats, def, room) {
var cov = productMatches(key) ? coveragePerLitre(def) : { v: def, known: false };
var litres = area * coats / cov.v * 1.1;
var lines = ['Area to paint: ' + round1(area) + 'm² x ' + coats + ' coat' + (coats > 1 ? 's' : '') + '.', 'Based on ' + round1(cov.v) + 'm² per litre' + (cov.known ? ' (from the product details)' : ' (a typical figure; check the tin)') + ', plus 10% spare.'];
var items = [];
var t = productMatches(key) ? tinLitres() : null;
var big = round1(litres) + ' litres';
if (t) {
var tins = Math.max(1, ceil(litres / t));
big = tins + ' x ' + t + 'L tin' + (tins > 1 ? 's' : '');
lines.unshift('About ' + round1(litres) + ' litres in total.');
items = mainItem(key, tins);
}
return { big: big, lines: lines, items: items, room: room };
}
function planView(key) {
var g = G[key];
var make = PLANNERS[g.planner];
var pl = make(key);
return {
title: g.title,
draw: function (el) {
var h = '<div class="nv-hero nv-hero--sm nv-hero--' + (GRP[key] || 'tool') + '">' + badge(key, 28, 'nv-hero__ic') + '<div><strong>Your measurements</strong><small>We work out what you need and build your list</small></div></div>';
h += '<form class="nv-form" id="nv-plan-form" novalidate>' + pl.fields + '<button class="nv-btn nv-full" type="submit">Work it out</button></form><div id="nv-out"></div>';
el.innerHTML = h;
var form = el.querySelector('#nv-plan-form');
form.addEventListener('submit', function (e) {
e.preventDefault();
var res = pl.calc(formVals(form));
showResult(el.querySelector('#nv-out'), key, res);
});
}
};
}
function showResult(out, key, res) {
var g = G[key];
var picks = (D.key === key && D.picks) ? D.picks : [];
var items = (res.items || []).concat(picks.map(function (p) { return { title: p.title, url: p.url, variantId: p.variantId, price: p.price, image: p.image, qty: 1, checked: false, label: p.label }; }));
var h = '<div class="nv-result"><small>You need about</small><div class="nv-result__big">' + esc(res.big) + '</div><ul class="nv-list">' + res.lines.map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('') + '</ul>';
if (res.room || res.shelf) h += '<canvas class="nv-room" id="nv-room" width="440" height="280" aria-label="Simple drawing of your space"></canvas>' + (res.room && res.room.mode !== 'floor' ? '<div class="nv-colours" id="nv-colours"></div>' : '') + '<p class="nv-muted">A simple drawing to help you picture it. Colours on screen are a guide only.</p>';
h += '</div>';
if (items.length) {
h += '<h3>Your shopping list</h3><ul class="nv-items">' + items.map(function (it, i) {
return '<li class="nv-item"><input type="checkbox" data-i="' + i + '"' + (it.checked ? ' checked' : '') + ' aria-label="Add ' + esc(it.title) + '"><img src="' + esc(it.image || '') + '" alt="" loading="lazy"><a href="' + esc(it.url) + '">' + (it.label ? '<span class="nv-muted">' + esc(it.label) + ':</span> ' : '') + esc(it.title) + '</a><span class="nv-qty">' + it.qty + ' x ' + money(it.price) + '</span></li>';
}).join('') + '</ul><button type="button" class="nv-btn" id="nv-add">Add ticked items to basket</button><div id="nv-add-msg" class="nv-msg"></div>';
} else {
h += '<h3>Shop for this project</h3>' + needsHtml(key);
}
if (D.emailOn) {
h += '<h3>Email me this plan</h3><form class="nv-form" id="nv-mail" novalidate><label class="nv-full">Email address<input type="email" name="email" autocomplete="email" required></label>' + field('mk', 'Also join the free Home Club: seasonal home reminders and offers (unsubscribe at any time)', false, { check: true }) + '<button class="nv-btn nv-btn--ghost nv-full" type="submit">Send my plan</button></form><div id="nv-mail-msg" class="nv-msg"></div>';
}
out.innerHTML = h;
if (res.room) drawRoom(res.room, '#d9e4e4');
if (res.shelf) drawShelf(res.shelf);
var sw = out.querySelector('#nv-colours');
if (sw) {
['#f3efe6', '#d9e4e4', '#c9d6e3', '#e7d3c1', '#b8c9a9', '#2f4a68', '#8b5e4a', '#5f6b73'].forEach(function (c, i) {
var b = document.createElement('button'); b.type = 'button'; b.className = 'nv-sw'; b.style.background = c; b.setAttribute('aria-label', 'Wall colour ' + (i + 1)); b.setAttribute('aria-pressed', i === 1 ? 'true' : 'false');
b.addEventListener('click', function () { sw.querySelectorAll('.nv-sw').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); b.setAttribute('aria-pressed', 'true'); drawRoom(res.room, c); });
sw.appendChild(b);
});
}
var add = out.querySelector('#nv-add');
if (add) add.addEventListener('click', function () {
var sel = [];
out.querySelectorAll('.nv-item input[type=checkbox]').forEach(function (c) { if (c.checked) { var it = items[+c.getAttribute('data-i')]; sel.push({ id: it.variantId, quantity: it.qty }); } });
var msg = out.querySelector('#nv-add-msg');
if (!sel.length) { msg.className = 'nv-msg nv-msg--err'; msg.textContent = 'Tick at least one item first.'; return; }
add.disabled = true;
fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: sel }) })
.then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
.then(function () {
msg.className = 'nv-msg nv-msg--ok'; msg.innerHTML = 'Added to your basket. <a class="nv-link" href="/cart">View basket</a>';
document.dispatchEvent(new CustomEvent('cart:refresh'));
fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (s) { s.textContent = c.item_count; }); }).catch(function () {});
})
.catch(function (err) { msg.className = 'nv-msg nv-msg--err'; msg.textContent = (err && err.description) ? err.description : 'Sorry, that did not work. Please add the items from their pages.'; })
.then(function () { add.disabled = false; });
});
var mail = out.querySelector('#nv-mail');
if (mail) mail.addEventListener('submit', function (e) {
e.preventDefault();
var v = formVals(mail), msg = out.querySelector('#nv-mail-msg');
if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.email || '')) { msg.className = 'nv-msg nv-msg--err'; msg.textContent = 'Please enter a valid email address.'; return; }
var btn = mail.querySelector('button'); btn.disabled = true;
var list = items.map(function (it) { return { title: it.title, qty: it.qty, price: (it.price / 100).toFixed(2), url: location.origin + it.url }; });
var props = { project: g.title, needed: res.big, details: res.lines, items: list, guide_steps: g.steps, page: location.href };
sendEvent(v.email, props).then(function () {
if (v.mk) return subscribe(v.email, D.club, 'Home Club - plan email');
}).then(function () {
msg.className = 'nv-msg nv-msg--ok'; msg.textContent = 'Thanks. Your plan is on its way to ' + v.email + '.';
}).catch(function () {
msg.className = 'nv-msg nv-msg--err'; msg.textContent = 'Sorry, we could not send that just now. Please try again.';
btn.disabled = false;
});
});
out.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
function kpost(path, payload) {
return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(D.klaviyo), {
method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2025-01-15' }, body: JSON.stringify(payload)
}).then(function (r) { if (!r.ok) throw new Error('k' + r.status); return r; });
}
function sendEvent(email, props) {
return kpost('events', { data: { type: 'event', attributes: { properties: props, metric: { data: { type: 'metric', attributes: { name: 'Project Plan Requested' } } }, profile: { data: { type: 'profile', attributes: { email: email } } } } } });
}
function subscribe(email, listId, source) {
return kpost('subscriptions', { data: { type: 'subscription', attributes: { custom_source: source || 'Project helper', profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: listId || D.list } } } } });
}
function shade(hex, f) {
var n = parseInt(hex.slice(1), 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255;
r = Math.round(r * f); g = Math.round(g * f); b = Math.round(b * f);
return 'rgb(' + Math.min(255, r) + ',' + Math.min(255, g) + ',' + Math.min(255, b) + ')';
}
function drawRoom(rm, colour) {
var cv = document.getElementById('nv-room'); if (!cv) return;
var ctx = cv.getContext('2d'), Wc = cv.width, Hc = cv.height;
ctx.clearRect(0, 0, Wc, Hc);
var L = Math.max(0.5, rm.L || 4), W = Math.max(0.5, rm.W || 3), H = Math.max(1, rm.H || 2.4);
var c30 = Math.cos(Math.PI / 6), s30 = 0.5;
var s = Math.min((Wc - 40) / ((L + W) * c30), (Hc - 40) / ((L + W) * s30 + H));
var ox = 20 + W * c30 * s, oy = 20 + H * s;
function p(x, y, z) { return [ox + (x - y) * c30 * s, oy + (x + y) * s30 * s - z * s]; }
function poly(pts, fill, stroke) { ctx.beginPath(); pts.forEach(function (q, i) { var a = p(q[0], q[1], q[2]); if (i) ctx.lineTo(a[0], a[1]); else ctx.moveTo(a[0], a[1]); }); ctx.closePath(); if (fill) { ctx.fillStyle = fill; ctx.fill(); } ctx.strokeStyle = stroke || '#9aa5b1'; ctx.lineWidth = 1; ctx.stroke(); }
var wallA = rm.mode === 'floor' ? '#eef1f4' : colour, wallB = rm.mode === 'floor' ? '#e6eaee' : colour;
poly([[0, 0, 0], [L, 0, 0], [L, W, 0], [0, W, 0]], rm.mode === 'floor' ? '#f7f4ee' : '#efe9df');
poly([[0, 0, 0], [L, 0, 0], [L, 0, H], [0, 0, H]], shade(wallA.charAt(0) === '#' ? wallA : '#eef1f4', 0.96));
poly([[0, 0, 0], [0, W, 0], [0, W, H], [0, 0, H]], shade(wallB.charAt(0) === '#' ? wallB : '#e6eaee', 0.86));
if (rm.mode === 'paper') {
ctx.save(); ctx.globalAlpha = 0.18; ctx.strokeStyle = '#1F3556';
for (var x = 0.53; x < L; x += 0.53) { var a = p(x, 0, 0), b = p(x, 0, H); ctx.beginPath(); ctx.moveTo(a[0], a[1]); ctx.lineTo(b[0], b[1]); ctx.stroke(); }
for (var y = 0.53; y < W; y += 0.53) { var a2 = p(0, y, 0), b2 = p(0, y, H); ctx.beginPath(); ctx.moveTo(a2[0], a2[1]); ctx.lineTo(b2[0], b2[1]); ctx.stroke(); }
ctx.restore();
}
if (rm.tile) {
var tw = Math.max(5, rm.tile[0]) / 100, th = Math.max(5, rm.tile[1]) / 100;
ctx.save(); ctx.globalAlpha = 0.35; ctx.strokeStyle = '#5b6573';
if (rm.mode === 'floor') {
for (var i = tw; i < L; i += tw) { var f1 = p(i, 0, 0), f2 = p(i, W, 0); ctx.beginPath(); ctx.moveTo(f1[0], f1[1]); ctx.lineTo(f2[0], f2[1]); ctx.stroke(); }
for (var j = th; j < W; j += th) { var g1 = p(0, j, 0), g2 = p(L, j, 0); ctx.beginPath(); ctx.moveTo(g1[0], g1[1]); ctx.lineTo(g2[0], g2[1]); ctx.stroke(); }
} else {
var top = Math.min(H, rm.tileH || 1.2);
poly([[0, 0, 0], [L, 0, 0], [L, 0, top], [0, 0, top]], 'rgba(255,255,255,0.55)', '#5b6573');
for (var k = tw; k < L; k += tw) { var h1 = p(k, 0, 0), h2 = p(k, 0, top); ctx.beginPath(); ctx.moveTo(h1[0], h1[1]); ctx.lineTo(h2[0], h2[1]); ctx.stroke(); }
for (var m = th; m < top; m += th) { var k1 = p(0, 0, m), k2 = p(L, 0, m); ctx.beginPath(); ctx.moveTo(k1[0], k1[1]); ctx.lineTo(k2[0], k2[1]); ctx.stroke(); }
}
ctx.restore();
}
if ((rm.windows || 0) > 0 && L > 1.4) poly([[L / 2 - 0.6, 0, 1.0], [L / 2 + 0.6, 0, 1.0], [L / 2 + 0.6, 0, 2.0], [L / 2 - 0.6, 0, 2.0]], '#dff0fb', '#7a8a99');
if ((rm.doors || 0) > 0 && W > 1.2) poly([[0, W / 2 - 0.4, 0], [0, W / 2 + 0.4, 0], [0, W / 2 + 0.4, Math.min(2.0, H - 0.1)], [0, W / 2 - 0.4, Math.min(2.0, H - 0.1)]], '#c9a77c', '#7a6347');
ctx.fillStyle = '#1F3556'; ctx.font = '12px sans-serif';
var la = p(L / 2, 0, 0); ctx.fillText(round1(L) + 'm', la[0] + 6, la[1] + 16);
var lb = p(0, W / 2, 0); ctx.fillText(round1(W) + 'm', lb[0] - 40, lb[1] + 16);
var lh = p(0, 0, H / 2); ctx.fillText(round1(H) + 'm', lh[0] + 4, lh[1]);
}
function drawShelf(sh) {
var cv = document.getElementById('nv-room'); if (!cv) return;
var ctx = cv.getContext('2d'), Wc = cv.width, Hc = cv.height;
ctx.clearRect(0, 0, Wc, Hc);
ctx.fillStyle = '#eef1f4'; ctx.fillRect(0, 0, Wc, Hc);
var len = Math.max(20, sh.len || 90), s = (Wc - 60) / len, x0 = 30, y = Hc / 2;
ctx.fillStyle = '#b98b5e'; ctx.fillRect(x0, y - 10, len * s, 12);
var gap = (len - 10) / (sh.per - 1);
for (var i = 0; i < sh.per; i++) {
var bx = x0 + (5 + i * gap) * s;
ctx.fillStyle = '#5b6573'; ctx.fillRect(bx - 3, y + 2, 6, 40); ctx.beginPath(); ctx.moveTo(bx - 3, y + 2); ctx.lineTo(bx + 22, y + 2); ctx.lineTo(bx - 3, y + 38); ctx.closePath(); ctx.globalAlpha = 0.4; ctx.fill(); ctx.globalAlpha = 1;
ctx.fillStyle = '#1F3556'; ctx.beginPath(); ctx.arc(bx, y + 12, 2.5, 0, 6.3); ctx.fill(); ctx.beginPath(); ctx.arc(bx, y + 32, 2.5, 0, 6.3); ctx.fill();
}
ctx.fillStyle = '#1F3556'; ctx.font = '12px sans-serif';
ctx.fillText(Math.round(len) + 'cm shelf, ' + sh.per + ' brackets about ' + Math.round(gap) + 'cm apart', x0, y - 22);
}
})();